module.exports = __webpack_public_path__ + "static/media/laptop.bf9d8a5b.gif";